// // import { useEffect, useState } from "react";
// // import axios from "axios";
// // import { apiurl } from "../config/config";

// // const InterviewQueueBoard = () => {
// //   const [current, setCurrent] = useState(null);
// //   const [next, setNext] = useState(null);
// //   const [allApps, setAllApps] = useState([]);
// //   const [isSpeechEnabled, setIsSpeechEnabled] = useState(false);


// // const speakText = (text, lang = "en-US") => {
// //     return new Promise((resolve) => {
// //       if (!isSpeechEnabled || !window.speechSynthesis) return resolve();
  
// //       const utterance = new SpeechSynthesisUtterance(text);
// //       utterance.lang = lang;
// //       utterance.pitch = 1;
// //       utterance.rate = 0.95;
  
// //       utterance.onend = () => resolve(); // Wait for speech to finish
// //       window.speechSynthesis.speak(utterance);
// //     });
// //   };
// //   const fetchData = async () => {
// //     try {
// //       const res = await axios.post(`${apiurl}/api/application/queue`);
// //       const { current, next, all } = res.data;
// //       setCurrent(current);
// //       setNext(next);
// //       setAllApps(all);

// //     //   if (current && next) {
// //     //     const msg = `Application ${current.id}, ${current?.candidateSnapshot?.firstName}, your interview is starting. Please enter the cabin. Next is Application ${next.id}, ${next?.candidateSnapshot?.firstName}, please be prepared.`;
// //     //     const msgHindi = `आवेदन संख्या ${current.id}, ${current.candidateSnapshot.firstName}, आपका इंटरव्यू शुरू हो रहा है। कृपया केबिन में आएं। अगला है आवेदन संख्या ${next.id}, ${next.candidateSnapshot.firstName}, कृपया तैयार रहें।`;
// //     //     speakText(msg);
        
// //     //     speakTextHi (msgHindi);
// //     //   }

// //     if (current && next) {
// //         const msgEn = `Application ${current.id}, ${current?.candidateSnapshot?.firstName}, your interview is starting. Please enter the cabin. Next is Application ${next.id}, ${next?.candidateSnapshot?.firstName}, please be prepared.`;
  
// //         const msgHi = `आवेदन संख्या ${current.id}, ${current.candidateSnapshot.firstName}, आपका इंटरव्यू शुरू हो रहा है। कृपया केबिन में आएं। अगला है आवेदन संख्या ${next.id}, ${next.candidateSnapshot.firstName}, कृपया तैयार रहें।`;
  
// //         await speakText(msgEn, "en-US");   // First speak English
// //         await speakText(msgHi, "hi-IN");   // Then speak Hindi
// //       }

// //     //   if (current && next) {
// //     //     const msg = `आवेदन संख्या ${current.id}, ${current.candidateSnapshot.firstName}, आपका इंटरव्यू शुरू हो रहा है। कृपया केबिन में आएं। अगला है आवेदन संख्या ${next.id}, ${next.candidateSnapshot.firstName}, कृपया तैयार रहें।`;
// //     //     speakTextHi(msg);
// //     //   }
// //     } catch (err) {
// //       console.error("Failed to fetch queue:", err);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchData();
// //     const interval = setInterval(() => {
// //       fetchData();
// //     }, 15000);
// //     return () => clearInterval(interval);
// //   }, [isSpeechEnabled]);

// //   return (
// //     <div className="w-full bg-gradient-to-br from-blue-100 to-white flex flex-col items-center justify-center p-6">
// //       <div className="max-w-6xl w-full text-center space-y-10">
// //         <h1 className="text-6xl font-extrabold text-blue-900 mb-10 animate-bounce">🎤 Interview Queue</h1>

// //         {!isSpeechEnabled && (
// //           <button
// //             onClick={() => setIsSpeechEnabled(true)}
// //             className="px-6 py-3 bg-blue-700 text-white text-xl rounded shadow-lg hover:bg-blue-800 transition-all"
// //           >
// //             🔊 Enable Voice Announcements
// //           </button>
// //         )}

// //         {/* Now Interviewing */}
// //         <div className="bg-green-100 p-6 rounded-xl shadow-xl animate-pulse border-4 border-green-500">
// //           <div className="text-5xl font-bold text-green-800">🎯 Now Interviewing</div>
// //           <div className="text-7xl text-green-900 font-extrabold mt-4 tracking-wide">
// //             {current?.id || "None"} — {current?.candidateSnapshot?.firstName || ""}
// //           </div>
// //         </div>

// //         {/* Next */}
// //         <div className="bg-yellow-100 p-6 rounded-xl shadow-xl border-4 border-yellow-500 animate-bounce mt-6">
// //           <div className="text-4xl font-bold text-yellow-700">⏭️ Next Candidate</div>
// //           <div className="text-6xl text-yellow-800 font-extrabold mt-4 tracking-wide animate-pulse">
// //             {next?.id || "Waiting..."} — {next?.candidateSnapshot?.firstName || ""}
// //           </div>
// //         </div>

// //         {/* List of All Applications */}
// //         <div className="overflow-y-auto max-h-[300px] shadow-inner border-2 border-gray-200 rounded-lg bg-white p-4 mt-10">
// //           <ul className="space-y-3 text-2xl">
// //             {allApps.map((app) => (
// //               <li
// //                 key={app._id}
// //                 className={`p-4 rounded-xl font-semibold text-center transition-all duration-300 ${
// //                   app.applicationStatus === "interviewing"
// //                     ? "bg-green-300 text-green-900 scale-105 shadow-lg"
// //                     : app.id === next?.id
// //                     ? "bg-yellow-200 text-yellow-900 shadow-md"
// //                     : "bg-gray-100 text-gray-700"
// //                 }`}
// //               >
// //                 ID: {app.id} — {app?.candidateSnapshot?.firstName || "N/A"} —{" "}
// //                 <span className="capitalize">{app.applicationStatus}</span>
// //               </li>
// //             ))}
// //           </ul>
// //         </div>
// //       </div>
// //       <div className="w-full h-screen bg-gradient-to-b from-indigo-100 to-white flex flex-col items-center justify-center relative px-6 py-8">
      
// //       {/* NEXT in top corner */}
// //       <div className="absolute top-4 right-6 bg-yellow-100 border-2 border-yellow-400 rounded-xl px-4 py-2 shadow-lg animate-pulse">
// //         <p className="text-lg font-bold text-yellow-800">⏭️ अगला</p>
// //         <p className="text-2xl text-yellow-900 font-semibold">
// //           {next?.candidateSnapshot?.firstName || "-"} ({next?.id || "..."})
// //         </p>
// //       </div>

// //       {/* Currently Interviewing */}
// //       <div className="text-center animate-fadeInUp">
// //         <p className="text-5xl font-bold text-green-800 mb-4">🎯 अभी इंटरव्यू में</p>
// //         <h1 className="text-8xl font-extrabold text-green-900 animate- tracking-wide">
// //           {current?.candidateSnapshot?.firstName || "कोई नहीं"} <br />
// //           <span className="text-5xl">({current?.id || ""})</span>
// //         </h1>
// //       </div>

// //       {/* Bottom List (3 upcoming) */}
// //       <div className="absolute bottom-6 w-full max-w-4xl">
// //         <div className="bg-white rounded-xl shadow-inner p-4 border flex justify-around">
// //           {allApps
// //             .filter(app => app.applicationStatus !== 'interviewing' && app.id !== next?.id && app.id !== current?.id)
// //             .slice(0, 3)
// //             .map(app => (
// //               <div key={app._id} className="text-center text-gray-700">
// //                 <p className="text-md font-medium">आवेदक</p>
// //                 <p className="text-xl font-bold">{app.candidateSnapshot?.firstName}</p>
// //                 <p className="text-sm">ID: {app.id}</p>
// //               </div>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //     </div>
// //   );
// // };

// // export default InterviewQueueBoard;


// import { useEffect, useState } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { Volume2, VolumeX, Users, Mic } from "lucide-react";

// const InterviewQueueBoard = () => {
//   const [current, setCurrent] = useState(null);
//   const [next, setNext] = useState(null);
//   const [allApps, setAllApps] = useState([]);
//   const [isSpeechEnabled, setIsSpeechEnabled] = useState(true);

//   // --- Text to Speech Function ---
//   const speakText = (text, lang = "en-US") => {
//     return new Promise((resolve) => {
//       if (!isSpeechEnabled || !window.speechSynthesis) return resolve();
//       const utterance = new SpeechSynthesisUtterance(text);
//       utterance.lang = lang;
//       utterance.pitch = 1;
//       utterance.rate = 0.95;
//       utterance.onend = () => resolve();
//       window.speechSynthesis.speak(utterance);
//     });
//   };

//   // --- Fetch Queue Data ---
//   const fetchData = async () => {
//     try {
//       const res = await axios.post(`${apiurl}/api/application/queue`);
//       const { current, next, all } = res.data;
//       setCurrent(current);
//       setNext(next);
//       setAllApps(all);

//       if (current && next) {
//         const msgEn = `Application ${current.id}, ${current.candidateSnapshot?.firstName}, your interview is starting. Please enter the cabin. Next is Application ${next.id}, ${next.candidateSnapshot?.firstName}, please be prepared.`;
//         const msgHi = `आवेदन संख्या ${current.id}, ${current.candidateSnapshot?.firstName}, आपका इंटरव्यू शुरू हो रहा है। कृपया केबिन में आएं। अगला है आवेदन संख्या ${next.id}, ${next.candidateSnapshot?.firstName}, कृपया तैयार रहें।`;

//         await speakText(msgEn, "en-US");
//         await speakText(msgHi, "hi-IN");
//       }
//     } catch (err) {
//       console.error("Failed to fetch queue:", err);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     const interval = setInterval(fetchData, 15000);
//     return () => clearInterval(interval);
//   }, [isSpeechEnabled]);

//   return (
//     <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-white to-indigo-100 flex flex-col items-center justify-center relative overflow-hidden">
      
//       {/* Voice Toggle Button */}
//       <button
//         onClick={() => setIsSpeechEnabled(!isSpeechEnabled)}
//         className="absolute top-6 right-6 bg-white/80 backdrop-blur-lg border border-gray-300 shadow-md rounded-full p-3 hover:scale-105 transition-transform"
//         title={isSpeechEnabled ? "Mute Announcements" : "Unmute Announcements"}
//       >
//         {isSpeechEnabled ? (
//           <Volume2 className="text-blue-700 w-7 h-7" />
//         ) : (
//           <VolumeX className="text-red-600 w-7 h-7" />
//         )}
//       </button>

//       {/* Header */}
//       <div className="text-center mb-12 animate-fadeIn">
//         <h1 className="text-5xl md:text-6xl font-extrabold text-blue-900 tracking-tight drop-shadow-sm">
//           <Mic className="inline w-12 h-12 text-indigo-600 mb-2 animate-pulse" />{" "}
//           Interview Queue Board
//         </h1>
//         <p className="text-lg text-gray-600 mt-2">
//           Real-time updates for ongoing and upcoming interviews
//         </p>
//       </div>

//       {/* Current Interview Section */}
//       <div className="bg-green-50 border-4 border-green-400 shadow-2xl rounded-3xl p-8 w-full max-w-4xl text-center transition-all hover:scale-[1.01] duration-300">
//         <p className="text-3xl md:text-4xl font-bold text-green-800 mb-3">🎯 Now Interviewing</p>
//         <h2 className="text-6xl md:text-7xl font-extrabold text-green-900 animate-pulse">
//           {current?.candidateSnapshot?.firstName || "No Candidate"}
//         </h2>
//         <p className="text-xl text-green-700 mt-3">
//           ID: <span className="font-bold">{current?.id || "----"}</span>
//         </p>
//       </div>

//       {/* Next Candidate Section */}
//       <div className="bg-yellow-50 border-4 border-yellow-400 shadow-2xl rounded-3xl p-8 w-full max-w-4xl text-center mt-10 transition-all hover:scale-[1.01] duration-300">
//         <p className="text-3xl md:text-4xl font-bold text-yellow-700 mb-3">⏭️ Next Candidate</p>
//         <h2 className="text-5xl md:text-6xl font-extrabold text-yellow-800 animate-bounce">
//           {next?.candidateSnapshot?.firstName || "Waiting..."}
//         </h2>
//         <p className="text-xl text-yellow-700 mt-3">
//           ID: <span className="font-bold">{next?.id || "----"}</span>
//         </p>
//       </div>

//       {/* Upcoming Candidates List */}
//       <div className="mt-12 w-full max-w-5xl bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200 p-6">
//         <div className="flex items-center mb-4">
//           <Users className="text-blue-600 w-7 h-7 mr-2" />
//           <h3 className="text-2xl font-bold text-blue-800">Upcoming Candidates</h3>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
//           {allApps
//             .filter(
//               (app) =>
//                 app.id !== current?.id &&
//                 app.id !== next?.id &&
//                 app.applicationStatus !== "interviewing"
//             )
//             .slice(0, 6)
//             .map((app) => (
//               <div
//                 key={app._id}
//                 className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-4 shadow hover:shadow-md transition-all text-center"
//               >
//                 <p className="text-lg font-semibold text-gray-800">
//                   {app.candidateSnapshot?.firstName}
//                 </p>
//                 <p className="text-sm text-gray-500">ID: {app.id}</p>
//                 <span
//                   className={`inline-block mt-2 px-3 py-1 rounded-full text-sm font-medium ${
//                     app.applicationStatus === "waiting"
//                       ? "bg-blue-100 text-blue-800"
//                       : "bg-gray-100 text-gray-600"
//                   }`}
//                 >
//                   {app.applicationStatus}
//                 </span>
//               </div>
//             ))}
//         </div>
//       </div>

//       {/* Background Gradient Blur */}
//       <div className="absolute inset-0 -z-10 bg-gradient-to-b from-blue-100/60 to-white blur-3xl"></div>
//     </div>
//   );
// };

// export default InterviewQueueBoard;
import { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import { Volume2, VolumeX, Users, Mic } from "lucide-react";

export default function InterviewQueueBoard() {
  const [current, setCurrent] = useState(null);
  const [next, setNext] = useState(null);
  const [allApps, setAllApps] = useState([]);
  const [isSpeechEnabled, setIsSpeechEnabled] = useState(true);

  // 🗣️ Speak Function (Sequential English → Hindi)
  const speakText = (text, lang = "en-US") => {
    return new Promise((resolve) => {
      if (!isSpeechEnabled || !window.speechSynthesis) return resolve();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = lang;
      utterance.pitch = 1;
      utterance.rate = 0.95;
      utterance.onend = () => resolve();
      window.speechSynthesis.speak(utterance);
    });
  };

  const fetchData = async () => {
    try {
      const res = await axios.post(`${apiurl}/api/application/queue`);
      const { current, next, all } = res.data;
      setCurrent(current);
      setNext(next);
      setAllApps(all);

      if (current && next) {
        const msgEn = `Application ${current.id}, ${current.candidateSnapshot?.firstName}, your interview is starting. Please enter the cabin. Next is Application ${next.id}, ${next.candidateSnapshot?.firstName}, please be prepared.`;
        const msgHi = `आवेदन संख्या ${current.id}, ${current.candidateSnapshot?.firstName}, आपका इंटरव्यू शुरू हो रहा है। कृपया केबिन में आएं। अगला है आवेदन संख्या ${next.id}, ${next.candidateSnapshot?.firstName}, कृपया तैयार रहें।`;
        await speakText(msgEn, "en-US");
        await speakText(msgHi, "hi-IN");
      }
    } catch (err) {
      console.error("Queue fetch failed:", err);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 15000);
    return () => clearInterval(interval);
  }, [isSpeechEnabled]);

  return (
    <div className="h-screen w-full flex flex-col bg-gradient-to-br from-indigo-100 via-white to-blue-50 relative overflow-hidden">
      {/* Voice Toggle */}
      <button
        onClick={() => setIsSpeechEnabled(!isSpeechEnabled)}
        className="absolute top-6 right-6 bg-white/70 backdrop-blur-lg border border-gray-300 rounded-full shadow-md p-3 hover:scale-105 transition-transform z-50"
        title={isSpeechEnabled ? "Mute Announcements" : "Unmute Announcements"}
      >
        {isSpeechEnabled ? (
          <Volume2 className="text-blue-700 w-7 h-7" />
        ) : (
          <VolumeX className="text-red-600 w-7 h-7" />
        )}
      </button>

      {/* Header */}
      <div className="text-center py-6 border-b border-gray-200 bg-white/80 backdrop-blur-md shadow-sm">
        <h1 className="text-5xl font-extrabold text-blue-900 tracking-tight flex justify-center items-center gap-3">
          <Mic className="text-indigo-600 w-10 h-10 animate-pulse" />
          Interview Queue Board
        </h1>
        <p className="text-gray-500 text-lg mt-1">
          Real-time display for ongoing and upcoming interviews
        </p>
      </div>

      {/* Split Screen */}
      <div className="flex flex-1 items-center justify-between px-6 py-8 gap-6">
        {/* LEFT: Now Interviewing */}
        <div className="flex-1 bg-gradient-to-br from-green-50 to-white border-4 border-green-400 shadow-2xl rounded-3xl p-8 text-center animate-fadeIn">
          <h2 className="text-3xl font-bold text-green-800 mb-3">🎯 Now Interviewing</h2>
          <p className="text-7xl font-extrabold text-green-900 animate-pulse">
            {current?.candidateSnapshot?.firstName || "No Candidate"}
          </p>
          <p className="text-xl text-green-700 mt-4">
            Application ID:{" "}
            <span className="font-bold">{current?.id || "----"}</span>
          </p>
        </div>

        {/* RIGHT: Next Candidate */}
        <div className="flex-1 bg-gradient-to-br from-yellow-50 to-white border-4 border-yellow-400 shadow-2xl rounded-3xl p-8 text-center animate-fadeIn delay-300">
          <h2 className="text-3xl font-bold text-yellow-700 mb-3">⏭️ Next Candidate</h2>
          <p className="text-6xl font-extrabold text-yellow-800 animate-bounce">
            {next?.candidateSnapshot?.firstName || "Waiting..."}
          </p>
          <p className="text-xl text-yellow-700 mt-4">
            Application ID:{" "}
            <span className="font-bold">{next?.id || "----"}</span>
          </p>
        </div>
      </div>

      {/* BOTTOM: Upcoming List */}
      <div className="bg-white/90 backdrop-blur-sm border-t border-gray-200 shadow-inner py-4 px-6">
        <div className="flex items-center mb-2">
          <Users className="text-blue-600 w-6 h-6 mr-2" />
          <h3 className="text-xl font-bold text-blue-800">Upcoming Candidates</h3>
        </div>

        <div className="overflow-x-auto whitespace-nowrap no-scrollbar flex gap-4 py-2 animate-marquee">
          {allApps
            .filter(
              (app) =>
                app.id !== current?.id &&
                app.id !== next?.id &&
                app.applicationStatus !== "interviewing"
            )
            .slice(0, 8)
            .map((app) => (
              <div
                key={app._id}
                className="inline-block min-w-[220px] bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl p-4 shadow hover:shadow-md text-center transition-all"
              >
                <p className="text-lg font-semibold text-gray-800">
                  {app.candidateSnapshot?.firstName}
                </p>
                <p className="text-sm text-gray-500">ID: {app.id}</p>
                <span
                  className={`inline-block mt-2 px-3 py-1 rounded-full text-sm font-medium ${
                    app.applicationStatus === "waiting"
                      ? "bg-blue-100 text-blue-800"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {app.applicationStatus}
                </span>
              </div>
            ))}
        </div>
      </div>

      {/* Background Glow */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-blue-100/50 via-white to-indigo-100 blur-3xl"></div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.6s ease-in-out forwards;
        }
        .animate-marquee {
          animation: scroll 25s linear infinite;
        }
        @keyframes scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
